export default "__VITE_ASSET__ksAZvIFF__"